import { Collapse } from 'bootstrap'
import Mark from 'mark.js'

export function registerAccordionSearch() {
  const accordionSearchForm = document.querySelectorAll('.accordion-search-form')
  accordionSearchForm.forEach(f => {
    f.addEventListener('submit', submitAccordionSearch)
  })
}

function submitAccordionSearch(event) {
  event.preventDefault()
  const regExpTerm = new RegExp(event.target.querySelector('input[name="q"]')?.value, 'gi')
  const accordionId = event.target.dataset.accordionTarget
  const accordion = document.querySelector(`.accordion[data-accordion-id="${accordionId}"]`)

  if (accordion) {
    const mark = new Mark(accordion)
    mark.unmark()
    mark.markRegExp(regExpTerm, { element: 'span', className: 'highlight' })

    const collapses = accordion.querySelectorAll('.accordion-collapse')
    let matchFound = false

    // Expand the collapses containing the matched text
    collapses.forEach(c => {
      const bsCollapse = Collapse.getOrCreateInstance(c, { toggle: false })

      if (c.parentElement.textContent.match(regExpTerm)) {
        matchFound = true
        bsCollapse.show()
      } else {
        bsCollapse.hide()
      }
    })

    // Show/hide no results message, and scroll user to first match
    const noResultsElement = event.target.querySelector('.accordion-search-no-results')
    if (matchFound) {
      noResultsElement?.classList.add('d-none')
      const firstHighlight = accordion.querySelector('.highlight')
      if (firstHighlight) {
        firstHighlight.scrollIntoView(true)
      }
    } else {
      noResultsElement?.classList.remove('d-none')
    }
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  registerAccordionSearch()
});